// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Base-cls1___94073d0305219e69715{/*!*/}.Base-cls2__aca80faf58ba068780c9{width:130px;flex-shrink:0;padding-left:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Base-cls1___94073d0305219e69715",
	"cls2": "Base-cls2__aca80faf58ba068780c9 Base-cls1___94073d0305219e69715"
};
export default ___CSS_LOADER_EXPORT___;
